import React, {useCallback, useContext, useState} from 'react';

export const MessageContext = React.createContext({
  message: null,
  addMessage: () => {},
  addSuccessMessage: () => {},
  addErrorMessage: () => {},
  removeMessage: () => {},
  setMessage: () => {}
});

export default function MessageProvider({ children }) {
  const [message, setMessage] = useState(null);

  const removeMessage = () => setMessage(null);
  const addMessage = (message, status, title, buttons) => setMessage({
      message,
      status,
      title,
      buttons,
      closeBtnShow:true,
      closeBtnText:'Close',
      closeBtnClassname:'btn btn-outline-primary'
  });

  return (
    <MessageContext.Provider value={{
      message,
      addMessage: useCallback((message, buttons=[], title, status="info") => addMessage(message, status, title, buttons), []),
      addSuccessMessage: useCallback((message, buttons=[], status="success", title="Success") => addMessage(message, status, title, buttons), []),
      addErrorMessage: useCallback((message, buttons=[], status="danger", title="Error") => addMessage(message, status, title, buttons), []),
      removeMessage: useCallback(() => removeMessage(), []),
      setMessage: useCallback((params)=>setMessage({...params}), [])
    }}>
      {children}
    </MessageContext.Provider>
  );
}

export function useGlobalNotificationMessage() {
  const {message, addMessage, addErrorMessage, addSuccessMessage, removeMessage, setMessage} = useContext(MessageContext);
  return {
    message,
    addMessage,
    addSuccessMessage,
    addErrorMessage,
    removeMessage,
    setMessage
  };
}
